export var ReportStatusKey;
(function (ReportStatusKey) {
    ReportStatusKey["GeneratingMarketProfile"] = "generating_market_profile";
    ReportStatusKey["MarketProfileReady"] = "market_profile_ready";
    ReportStatusKey["GeneratingReport"] = "generating_report";
    ReportStatusKey["Completed"] = "completed";
    ReportStatusKey["Failed"] = "failed";
})(ReportStatusKey || (ReportStatusKey = {}));
export var ReportStatusChipColor;
(function (ReportStatusChipColor) {
    ReportStatusChipColor["Warning"] = "warning.main";
    ReportStatusChipColor["Info"] = "info.main";
    ReportStatusChipColor["Success"] = "success.main";
    ReportStatusChipColor["Error"] = "error.main";
})(ReportStatusChipColor || (ReportStatusChipColor = {}));
const STATUS_KEY_BY_ASSESSMENT_STATUS = {
    generating_market_profile: ReportStatusKey.GeneratingMarketProfile,
    market_profile_ready: ReportStatusKey.MarketProfileReady,
    generating_queries: ReportStatusKey.GeneratingReport,
    executing_queries: ReportStatusKey.GeneratingReport,
    aggregating: ReportStatusKey.GeneratingReport,
    completed: ReportStatusKey.Completed,
    failed: ReportStatusKey.Failed,
};
export const REPORT_STATUS_CHIP_COLORS = {
    [ReportStatusKey.GeneratingMarketProfile]: ReportStatusChipColor.Info,
    [ReportStatusKey.MarketProfileReady]: ReportStatusChipColor.Warning,
    [ReportStatusKey.GeneratingReport]: ReportStatusChipColor.Info,
    [ReportStatusKey.Completed]: ReportStatusChipColor.Success,
    [ReportStatusKey.Failed]: ReportStatusChipColor.Error,
};
export const getReportStatusKey = (status) => status ? STATUS_KEY_BY_ASSESSMENT_STATUS[status] : undefined;
